import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const GET_ADMIN_USER_FAIL = "ADMIN-USER:GET_ADMIN_USER_FAIL";

export interface GetAdminUserFailAction extends Action {
  type: typeof GET_ADMIN_USER_FAIL;
  organization: OrganizationKeyName;
  id: string;
}

export const getAdminUserFailAction = (
  organization: OrganizationKeyName,
  id: string
): GetAdminUserFailAction => ({
  type: GET_ADMIN_USER_FAIL,
  organization,
  id,
});
